export default __webpack_public_path__ + "static/media/welcome-male@2x.461158db.png";